export default __webpack_public_path__ + "static/media/materialize-logo.33a27f0e.svg";